<template>
  <div
    ref="frisbuy-widget-gallery"
    :class="{
      'frisbuy-widget': true,
      'frisbuy-class': true,
      'frisbuy-vertical': isVerticalGallery,
      [`frisbuy-layout-${gallerySettings.layout}`]: gallerySettings.layout,
      [`frisbuy-${settings.customerCode}`]: true,
    }"
    :style="[galleryStyle]"
  >
    <!-- <script src="https://connect.facebook.net/en_US/all.js" async="" type="application/javascript" v-if="settings.popup.shareButtons.fb"></script> -->
    <div class="frisbuy-header">
      <div
        class="frisbuy-title"
        v-if="headerSettings.title || headerSettings.buttonTitle"
      >
        {{ headerSettings.title }}
        <a v-if="headerSettings.buttonTitle" :href="headerSettings.buttonLink">
          {{ headerSettings.buttonTitle }}
        </a>
      </div>
      <div
        v-if="headerSettings.subTitle"
        class="frisbuy-subtitle"
        :style="[subTitleStyle]"
      >
        {{ headerSettings.subTitle }}
      </div>
      <div v-if="headerSettings.html" v-html="headerSettings.html"></div>
    </div>
    <div class="frisbuy-categories" v-if="gallerySettings.filters.params">
      <a
        v-for="filter in gallerySettings.filters.params"
        :href="`#tag=${filter.value ? filter.name : 'Все'}`"
        :class="{
          'frisbuy-category': true,
          'frisbuy-active':
            filterValue == filter.value ||
            (filterValue == null && !filter.value),
        }"
        @click="chosenFilter(filter)"
      >
        {{ filter.name }}
      </a>
    </div>
    <div class="frisbuy-gallery">
      <div
        :class="{
          'frisbuy-scroll-wrapper': true,
          'no-scroll-width': !isVerticalGallery && scrollWidth < 0,
        }"
        :style="{
          height:
            isVerticalGallery &&
            gallerySettings.maxCols &&
            `${
              (containerItemHeight + containerItemMargin) *
              gallerySettings.maxCols
            }px`,
        }"
        v-touch:swipe="swipeHandler"
        ref="postsScroll"
      >
        <div
          :style="{
            padding:
              isLineRowsMode &&
              scrollWidth < 0 &&
              `0 ${containerItemMargin / 2}px`,
          }"
        >
          <ul
            :class="{
              'frisbuy-gallery-posts': true,
              'frisbuy-gallery-multiline': isLineRowsMode,
              [`frisbuy-scheme-${gallerySettings.scheme}`]:
                gallerySettings.layout == 'tile' && gallerySettings.scheme,
            }"
            :style="{
              margin: `-${containerItemMargin / 2}px`,
              width: `calc(100% + ${containerItemMargin}px)`,
              maxHeight:
                !isVerticalGallery && isLineRowsMode && containerRowsHeight,
            }"
          >
            <template v-for="(post, index) in postList">
              <li
                v-if="
                  gallerySettings.scheme &&
                  !isTablet &&
                  (index == 5 || !((index - 5) % 9))
                "
                class="frisbuy-divider"
              ></li>
              <template
                v-if="post.frisbuyPost.type === 'advertising'"
              ></template>
              <post-item
                v-else
                :post="post"
                :key="post.frisbuyPost.id"
                :index="index"
                ref="postImage"
                :settings="settings"
                :mobile-settings="mobileSettings"
                :style="{
                  width: getPostItemWidth(index),
                  margin: `${containerItemMargin / 2}px`,
                }"
                :observer="imageObserver"
                @click="clickPostHandler(post, index)"
              >
              </post-item>
            </template>
          </ul>
        </div>
      </div>
      <div
        v-if="
          gallerySettings.layout == 'arrow' &&
          ((isVerticalGallery && scrollTop > 0) || scrollWidth > 0)
        "
        :class="{
          'frisbuy-gallery-navigation': true,
          'frisbuy-big': isLineRowsMode,
        }"
      >
        <div
          :class="{
            'frisbuy-navigation-button': true,
            'frisbuy-navigation-button-disabled': !canPrevScroll,
          }"
          @click="slideHandler(-1)"
        >
          <svg
            version="1.1"
            xmlns="http://www.w3.org/2000/svg"
            xmlns:xlink="http://www.w3.org/1999/xlink"
            viewBox="0 0 24 32"
            xml:space="preserve"
          >
            <polyline
              stroke="currentColor"
              fill="none"
              points="16,24 8,16 16,8"
            />
          </svg>
        </div>
        <span></span>
        <div
          :class="{
            'frisbuy-navigation-button': true,
            'frisbuy-navigation-button-disabled': !canNextScroll,
          }"
          @click="slideHandler(1)"
        >
          <svg
            version="1.1"
            xmlns="http://www.w3.org/2000/svg"
            xmlns:xlink="http://www.w3.org/1999/xlink"
            viewBox="0 0 24 32"
            xml:space="preserve"
          >
            <polyline
              stroke="currentColor"
              fill="none"
              points="8,8 16,16 8,24"
            />
          </svg>
        </div>
      </div>
    </div>
    <div
      v-if="gallerySettings.branding"
      :class="[{ 'frisbuy-branding': true }, gallerySettings.branding]"
    >
      Сделано на
      <a
        :href="
          settings.brandingLink ||
          'https://www.frisbuy.ru/?utm_source=gallery&utm_medium=referral&utm_campaign=' +
            settings.customerCode
        "
        rel="nofollow"
        target="_blank"
      >
        <img
          :src="`${envDomain}/images/widget/frisbuy_logo_gray.svg`"
          alt="Frisbuy"
        />
      </a>
    </div>
    <div
      class="frisbuy-footer"
      :style="{ marginTop: gallerySettings.loadMore.marginTop + 'px' }"
    >
      <PostsCounter
        :allPostsCount="postCount"
        :currentPostsCount="postList.length"
      />

      <SimpleButton v-if="isShowLoadmoreButton" @click="loadMoreHandler">
        {{ gallerySettings.loadMore.text || "Ещё" }}
        <span v-if="inLoading" class="frisbuy-loadmore-loader"></span>
      </SimpleButton>
      <div
        v-if="gallerySettings.footer.html"
        v-html="gallerySettings.footer.html"
      ></div>
    </div>
    <div
      v-if="gallerySettings.guideline.html && isGuidlineOpen"
      class="frisbuy-guideline"
    >
      <div class="frisbuy-guideline-container">
        <div v-html="gallerySettings.guideline.html"></div>
      </div>
    </div>
  </div>

  <Popup
    v-if="isShowPopup"
    :settings="settings"
    :mobileSettings="mobileSettings"
    :postList="postList"
    :post="currentPost"
    :postIndex="currentPostIndex"
    @changePost="
      (direction) =>
        selectPost(
          postList[currentPostIndex + direction],
          currentPostIndex + direction
        )
    "
    @close="() => closePopup()"
  />
</template>

<!-- TODO: refactor scoped styles to avoid copying them -->
<style scoped src="@/gallery/gallery/gallery.scss" lang="scss"></style>
<style scpoed lang="scss">
$lassiePrimaryColor: #002354;

* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}

.frisbuy-widget {
  &.frisbuy-layout-tile {
    .frisbuy-header {
      margin-bottom: 0;
    }
  }

  .frisbuy-header {
    .frisbuy-title {
      line-height: 36.4px;
    }

    .frisbuy-sub-title {
      line-height: 25.2px;

      color: #252d37;

      font-family: Factor A Light, sans-serif;
      font-weight: 300;
      line-height: 25.2px;

      margin-top: 12px;

      &,
      * {
        font-size: 18px;
      }

      span {
        color: $lassiePrimaryColor;
        font-weight: 400;
        line-height: 23.4px;
      }
    }
  }

  .frisbuy-gallery {
    margin-top: 40px;
  }

  .frisbuy-footer {
    .frisbuy-simple-button {
      background-color: $lassiePrimaryColor;
      color: #ffffff;
      border: 1px solid $lassiePrimaryColor;

      width: 100%;
      max-width: 420px;

      font-family: inherit;
      font-size: 16px;
      font-weight: 400;
      text-align: center;

      margin-top: 24px;

      &:hover {
        background-color: #ffffff;
        color: $lassiePrimaryColor;
      }

      .frisbuy-loadmore-loader {
        display: inline-block;
      }
    }
  }
}

@media screen and (max-width: 375px) {
  .frisbuy-widget {
    .frisbuy-header {
      .frisbuy-title {
        font-size: 28px;
      }

      .frisbuy-sub-title {
        margin-top: 10px;

        &,
        * {
          font-size: 16px;
          line-height: 20.8px;
        }
      }
    }
  }
}
</style>

<script>
import defaultGallery from "@/gallery/gallery/gallery.vue";
import Popup from "../popup/popup.vue";
import SimpleButton from "../components/SimpleButton.vue";
import PostsCounter from "../components/PostsCounter.vue";

export default {
  extends: defaultGallery,

  components: { Popup, SimpleButton, PostsCounter },

  data() {
    return {};
  },

  computed: {
    isMobile: {
      cache: false,
      get() {
        return this.containerWidthPx <= 767;
      },
    },
  },
};
</script>
